export enum MFACodes {
  NO_MFA = "NOMFA",
  NEW_PASSWORD_REQUIRED = "NEW_PASSWORD_REQUIRED",
  SMS_MFA = "SMS_MFA",
  SOFTWARE_TOKEN_MFA = "SOFTWARE_TOKEN_MFA",
  MFA_SETUP = "MFA_SETUP",
}
